import { api } from '../../ApiHandler';
import { CompleteUser } from '../../../types';

type Props = { email: string; captchaToken: string | null };
export const PasswordResetRequestRequest = ({
	email,
	captchaToken,
}: Props): Promise<{ data: CompleteUser }> => {
	return api()
		.post(
			'auth/reset-password',
			{ email },
			{
				headers: {
					'Content-Type': 'application/json',
					'X-CAPTCHA-Token': captchaToken,
				},
			},
		)
		.then(response => response.data);
};
